import Process from 'process'
import { Buffer as BufferPolyfill } from 'buffer'

declare const Buffer: typeof BufferPolyfill
globalThis.process = Process
globalThis.Buffer = BufferPolyfill
